module.exports = __webpack_public_path__ + "static/ud_usability_testing-3b318b01c3e22f0bfe1ea5b876ae5e31.svg";